import {EventEmitter} from "./EventEmitter";

export class BottomPane {
	constructor() {
		this.emitter = new EventEmitter();

		this.$bottom = $("#js-bottom-pane");

		this.initPane();
	}

	initPane() {
		this.setUpPaneListeners();
	}

	setUpPaneListeners() {
		$(document).on("click", ".js-bottom-pane-move", () => this.togglePane());
	}

	/* event listeners */
	pane(action, fn) {
		if (action === "expanded") this.emitter.subscribe("event:expanded", () => fn());

		if (action === "reduced") this.emitter.subscribe("event:reduced", () => fn());

		if (action === "show") this.emitter.subscribe("event:show-pane", () => fn());

		if (action === "hide") this.emitter.subscribe("event:hide-pane", () => fn());
	}

	togglePane() {
		return this.$bottom.hasClass("expanded") ? this.reduce() : this.expand();
	}

	expand() {
		this.$bottom.addClass("expanded");

		return this.emitter.emit("event:expanded");
	}

	reduce() {
		this.$bottom.removeClass("expanded");

		return this.emitter.emit("event:reduced");
	}

	show() {
		this.$bottom.addClass("active");

		return this.emitter.emit("event:show-pane");
	}

	hide() {
		this.reduce();
		this.$bottom.removeClass("active");

		return this.emitter.emit("event:hide-pane");
	}
}
